/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import styled from 'styled-components';
import Typography from '@ntuctech/devex-tangram/Typography';

import Link from '@ntuctech/devex-tangram/Link';

import { SCREEN_SIZE } from '../../lib/Media';
import Accordion from '../Accordion';
import { setUserType } from '../../utils/UserType';

const MainContainer = styled.div`
  background: #ffffff;
`;

const Container = styled.div`
  max-width: 75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px auto;
  padding: 4rem 3rem;
  ${SCREEN_SIZE.Below.Tablet} {
    margin-bottom: 0;
    padding: 3rem 2rem;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    margin-bottom: 0;
    padding: 2rem 1rem;
  }
`;

const Heading = styled(Typography).attrs({ variant: 'h2' })`
  text-align: center;
  margin-bottom: 4rem;
  ${SCREEN_SIZE.Below.Tablet} {
    margin-bottom: 3rem;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    margin-bottom: 2rem;
  }
`;

const FAQLink = styled(Link).attrs({ size: 'l' })`
  font-weight: 400;
  margin-left: 0.25rem;
`;

const LoadMore = styled(Link).attrs({ size: 'l' })`
  margin-top: 0.5rem;
`;

const MoreInfo = styled.div`
  padding: 1rem;
  background-color: #f1f6fe;
  color: #333;
  width: 100%;
  border-radius: 0.25rem;
  border: 1px solid #f1f6fe;
  margin-bottom: 1.125rem;
`;

const handleLandingPageNavigation = (mode) => {
  const windowVar = typeof window !== 'undefined' && window;
  if (mode === 'B2B') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    window.scrollTo({ top: 0 });
    windowVar.location.href = '/';
    setUserType(mode, true);
  }
};

const faqData = [
  {
    id: 1,
    question: 'What are FairPrice Group E-Gift Vouchers and how to redeem them?',
    answer: (
      <Typography variant="bodyM">
        E-Voucher is a prepaid digital voucher that can be used in FairPrice stores, Warehouse Club,
        Unity stores and online at FairPrice. <br />
        Recipients can tap on the voucher link to view the E-Vouchers in a web browser, or store it
        in their FairPrice account. To redeem, tap “Use now” to launch a QR code that can be
        redeemed in-stores and a voucher code for online redemptions. An E-Voucher can be drawn
        multiple times until the balance runs out or until expiry. Only the total transaction amount
        can be deducted from the E-Voucher; recipient cannot choose the specific value to be
        deducted. If the balance is below the transaction amount, the E-Voucher can be used and the
        remaining balance can be paid via other payment methods.
      </Typography>
    ),
  },
  {
    id: 2,
    question: 'Are there discounts for bulk or corporate purchase of E-Gift Vouchers?',
    answer: (
      <Typography variant="bodyM">
        Please contact the FairPrice Group E-Vouchers sales team at{' '}
        <Link size="l" href="mailto:fpvouchers@ntucenterprise.sg">
          fpvouchers@ntucenterprise.sg
        </Link>{' '}
        for more information.
      </Typography>
    ),
  },
  {
    id: 3,
    question: 'How are the E-Gift Vouchers issued?',
    answer: (
      <Typography variant="bodyM">
        All the E-Voucher details (voucher URLs, voucher codes, denominations and expiry dates) will
        be compiled in a CSV file, which will be password protected and emailed to you. A separate
        email containing the password will then be sent to you to access the CSV file.
      </Typography>
    ),
  },
  {
    id: 4,
    question:
      'Does the recipient need to download the FairPrice Group app to use the E-Gift Voucher?',
    answer: (
      <Typography variant="bodyM">
        No, the user does not need the FairPrice Group app to use the E-Voucher. The E-Voucher can
        be accessed via a standard web browser. <br />
        However, storing E-Vouchers to a FairPrice account allows seamless redemptions in-stores and
        online, and prevent instances of recipients losing the voucher URL link.
      </Typography>
    ),
  },
  {
    id: 5,
    question: 'How soon will I receive my order?',
    answer: (
      <Typography variant="bodyM">
        You will receive your purchased FairPrice Group E-Gift Vouchers within a few minutes after
        making a successful payment.
      </Typography>
    ),
  },
  {
    id: 6,
    question: 'Can I amend my order?',
    answer: (
      <Typography variant="bodyM">
        You cannot amend your order after making payment. Please email{' '}
        <Link size="l" href="mailto:fpvouchers@ntucenterprise.sg">
          fpvouchers@ntucenterprise.sg
        </Link>{' '}
        for further assistance.
      </Typography>
    ),
  },
  {
    id: 7,
    question: 'What is a Business account?',
    answer: (
      <Typography variant="bodyM">
        A business account allows you to self-serve your order and purchase FairPrice Group E-Gift
        Vouchers in bulk, you can choose the card design directly from the comfort of your desk.
      </Typography>
    ),
  },
  {
    id: 8,
    question: 'Can I request for an expiry date extension?',
    answer: (
      <Typography variant="bodyM">
        Unfortunately, we are unable to extend the validity of E-Vouchers once they have been
        issued.
      </Typography>
    ),
  },
  {
    id: 9,
    question: 'What types of vouchers can I purchase online?',
    answer: (
      <Typography variant="bodyM">
        You may purchase E-Gift Vouchers in bulk via this{' '}
        <Link size="l" data-testid="b2b-link" onClick={() => handleLandingPageNavigation('B2B')}>
          page
        </Link>
        . To purchase personal E-Gift Vouchers, please visit this{' '}
        <Link size="l" data-testid="b2c-link" onClick={() => handleLandingPageNavigation('B2C')}>
          page
        </Link>
        .
      </Typography>
    ),
  },
  {
    id: 10,
    question: 'I didn’t receive my order. What should I do?',
    answer: (
      <Typography variant="bodyM">
        If you haven&apos;t received your order 20 minutes after making payment, please email{' '}
        <Link size="l" href="mailto:fpvouchers@ntucenterprise.sg">
          fpvouchers@ntucenterprise.sg
        </Link>{' '}
        immediately.
      </Typography>
    ),
  },
  {
    id: 11,
    question: 'What are the accepted payment methods?',
    answer: (
      <Typography variant="bodyM">
        We accept credit or debit card payments for orders made via the website. For other methods
        of payment, please email{' '}
        <Link size="l" href="mailto:fpvouchers@ntucenterprise.sg">
          fpvouchers@ntucenterprise.sg
        </Link>
        .
      </Typography>
    ),
  },
];

const B2BFAQs = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 600);
  React.useEffect(() => {
    const updateWindowDimensions = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener('resize', updateWindowDimensions);

    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  const initialFaq = isMobile ? 3 : 6;
  const faqCount = faqData?.length;
  const [loadAllFAQ, setLoadAllFAQ] = React.useState(initialFaq);
  return (
    <>
      <MainContainer>
        <Container>
          <Heading>Frequently asked questions</Heading>
          {faqData.slice(0, loadAllFAQ).map((item) => (
            <Accordion title={item.question} key={item.question} b2b>
              <div>{item.answer}</div>
            </Accordion>
          ))}
          {loadAllFAQ === faqCount ? (
            <MoreInfo>
              For more information, visit our
              <FAQLink
                target="_blank"
                href="https://help.fairprice.com.sg/hc/en-us/sections/9514637359385-FairPrice-E-Gift-Vouchers"
              >
                Help Centre
              </FAQLink>
              .
            </MoreInfo>
          ) : null}
          {loadAllFAQ === initialFaq ? (
            <LoadMore onClick={() => setLoadAllFAQ(faqCount)}>Show all FAQs</LoadMore>
          ) : (
            <LoadMore onClick={() => setLoadAllFAQ(initialFaq)}>Show less FAQs</LoadMore>
          )}
        </Container>
      </MainContainer>
    </>
  );
};

export default B2BFAQs;
